function openTab(evt,tabName) {
//  console.log("evt="+evt+" tabName="+tabName);
  var i, x, tablinks, videotabs;
  x = document.getElementsByClassName("video");
  for (i = 0; i < x.length; i++) {
    x[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablink");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" videotab", "");
  }
  
  videotabs = document.getElementsByClassName("video");
  for (i = 0; i < x.length; i++) {
    videotabs[i].className = videotabs[i].className.replace(" videotab-opened", "");
  }
  
  document.getElementById(tabName).style.display = "block";
  
  document.getElementById(tabName).className += " videotab-opened";

  if(tabName=='bodyfocus') {
//    document.getElementsByClassName('searchanise-recommendations')[0].style.height='auto';
  }
  else {
//    document.getElementsByClassName('searchanise-recommendations')[0].style.height='0';
  }
  
  evt.currentTarget.className += " videotab";
}
